import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import {
    IRobot,
    RobotHostingType,
    RobotType,
} from '@models';
import {
    RobotCredentialsControl,
    RobotFormControl,
    RobotModalBaseComponent,
} from '@pages/robots/modal/robot-base.modal';
import { addToObjectIf } from '@utils/object.utils';

@Component({
    styleUrls: ['./robot.modal.scss'],
    templateUrl: './robot-floating.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingRobotModalComponent extends RobotModalBaseComponent {

    public get hostingType() {
        return RobotHostingType.Floating;
    }

    protected _getFormValueToCreateAnother = (robot: IRobot) => ({
        [RobotFormControl.hostingType]: robot.hostingType,
        [RobotFormControl.type]: [this._robotTypeToDropdownEntry(robot.type)],
        [RobotFormControl.isExternalLicense]: !!robot.isExternalLicense,
        ...addToObjectIf(
            robot.type !== RobotType.Attended, {
                [RobotFormControl.robotCredentials]: {
                    [RobotCredentialsControl.credentialStore]: [this._credentialStoreToDropdownEntry(this.selectedCredentialStore)],
                },
            }),
    })

    public get formTitle() {
        return this._translateService.instant('robot_modal_form_floating_title');
    }

    public get formDescription() {
        return this._translateService.instant('robot_modal_form_floating_info_text');
    }
}
